import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';

const contactInfo = [
  { icon: Phone, label: 'Telefon', value: '+49 155 10904109', href: 'tel:+4915510904109' },
  { icon: Mail, label: 'E-Mail', value: 'akw-design@gmx.de', href: 'mailto:akw-design@gmx.de' },
  { icon: MapPin, label: 'Standort', value: '35781 Weilburg', href: null }
];

export const Contact = () => {
  return (
    <section
      id="kontakt"
      className="py-24 lg:py-32 bg-slate-50 noise-bg"
      data-testid="contact-section"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 text-sm font-semibold rounded-full mb-4">
            KONTAKT
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4">
            Kontakt aufnehmen
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Haben Sie Fragen oder möchten ein Angebot? Wir freuen uns auf Ihre Nachricht.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {/* Email Card - Prominent */}
          <a
            href="mailto:akw-design@gmx.de?subject=Anfrage%20über%20Website"
            className="group lg:col-span-2 bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white shadow-xl hover:shadow-2xl hover:shadow-teal-500/20 transition-all duration-300 hover:-translate-y-1"
            data-testid="contact-email-card"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mb-6">
                  <Mail className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">E-Mail schreiben</h3>
                <p className="text-teal-100 mb-4">
                  Klicken Sie hier, um uns direkt eine E-Mail zu senden
                </p>
                <span className="text-xl font-semibold">akw-design@gmx.de</span>
              </div>
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center group-hover:bg-white/20 transition-colors">
                <ArrowRight className="w-6 h-6 text-white group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </a>

          {/* Phone Card */}
          <a
            href="tel:+4915510904109"
            className="group bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-lg hover:border-teal-200 transition-all duration-300 hover:-translate-y-1"
            data-testid="contact-phone-card"
          >
            <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-teal-100 transition-colors">
              <Phone className="w-7 h-7 text-teal-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">Anrufen</h3>
            <p className="text-slate-500 mb-4 text-sm">
              Mo - Fr: 9:00 - 18:00 Uhr
            </p>
            <span className="text-lg font-semibold text-teal-600">+49 155 10904109</span>
          </a>

          {/* WhatsApp Card */}
          <a
            href="https://wa.me/4915510904109"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-lg hover:border-green-200 transition-all duration-300 hover:-translate-y-1"
            data-testid="contact-whatsapp-card"
          >
            <div className="w-14 h-14 bg-green-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-100 transition-colors">
              <svg className="w-7 h-7 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-2">WhatsApp</h3>
            <p className="text-slate-500 mb-4 text-sm">
              Schnelle Antwort garantiert
            </p>
            <span className="text-lg font-semibold text-green-600">Nachricht senden</span>
          </a>

          {/* Location Card */}
          <div
            className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 lg:col-span-2"
            data-testid="contact-location-card"
          >
            <div className="flex items-start gap-6">
              <div className="w-14 h-14 bg-slate-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-7 h-7 text-slate-600" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Standort</h3>
                <p className="text-slate-500 mb-2">
                  AKW Design - Werbetechnik
                </p>
                <p className="text-lg font-semibold text-slate-700">
                  35781 Weilburg, Deutschland
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
